import React, { Suspense } from 'react'
import { Spin } from 'antd'
import { Switch, Route, useRouteMatch } from 'react-router-dom'
import UsersList from '../../container/user/grid'

const UserRoutes = () => {
  const { path } = useRouteMatch()
  return (
    <Switch>
      <Suspense
        fallback={
          <div className='spin'>
            <Spin />
          </div>
        }
      >
        <Route exact path={`${path}/`} component={UsersList} />
      </Suspense>
    </Switch>
  )
}
export default UserRoutes
